import { createSelector } from "reselect";

import { AppState } from "../../types";
import { AuthState } from "./types";

export const authStateSelector = ({ auth }: AppState): AuthState => auth;

export const userSelector = createSelector(
  authStateSelector,
  (authState) => authState.user
);
